import { env } from '@/config/env';
import { analyticsContract, usersContract } from '@skewb-works/contracts';
import { initQueryClient } from '@ts-rest/react-query';

/**
 * Base API URL from centralized config
 */
const API_BASE_URL = env.api.baseUrl;

/**
 * Analytics API base URL (includes /analytics prefix)
 */
const ANALYTICS_API_BASE_URL = `${API_BASE_URL}/analytics`;

/**
 * React Query client for analytics API
 *
 * Automatically generates React Query hooks from contract:
 * - useGetDashboardKpis()
 * - useGetJobsAnalytics()
 * - useGetPerformanceAnalytics()
 *
 * All hooks have proper TypeScript types for query params and responses.
 */
export const analyticsQueryClient = initQueryClient(analyticsContract, {
  baseUrl: ANALYTICS_API_BASE_URL,
  baseHeaders: {
    'Content-Type': 'application/json',
  },
  credentials: 'include',
});

/**
 * Users API base URL (includes /works-lite/users prefix)
 */
const USERS_API_BASE_URL = `${API_BASE_URL}/works-lite/users`;

/**
 * React Query client for users API
 *
 * Automatically generates React Query hooks from contract:
 * - useListUsers(), useGetUserDetail(), useCreateUser(), etc.
 */
export const usersQueryClient = initQueryClient(usersContract, {
  baseUrl: USERS_API_BASE_URL,
  baseHeaders: {
    'Content-Type': 'application/json',
  },
  credentials: 'include',
});
